import React, { useState } from "react";
import { ShieldCheck } from "lucide-react";
import { toast } from "sonner";
import api from "../lib/api";

const YEAR = 365 * 24 * 3600 * 1000;
const SNOOZE_KEY = "sojProfileCheckSnooze";

export const profileCheckDue = (m) => {
  if (!m?.id) return false;
  const last = m.profile_checked_at || m.created_at;
  return !last || Date.now() - new Date(last).getTime() > YEAR;
};

export const ProfileCheckCard = ({ member, onEdit, onDone }) => {
  const [snoozed, setSnoozed] = useState(() => Number(localStorage.getItem(SNOOZE_KEY) || 0) > Date.now());
  if (snoozed || !profileCheckDue(member)) return null;
  const confirmOk = async () => {
    try { await api.post("/portal/me/profile-checked"); toast.success("Thanks for confirming your details"); onDone(); }
    catch { toast.error("Couldn't save — please try again"); }
  };
  const later = () => { localStorage.setItem(SNOOZE_KEY, String(Date.now() + 7 * 24 * 3600 * 1000)); setSnoozed(true); };
  const emergency = [member.emergency_name, member.emergency_phone].filter(Boolean).join(" · ");
  const rows = [["Phone", member.phone], ["Email", member.email], ["Address", [member.address, member.postcode].filter(Boolean).join(", ")], ["Emergency contact", emergency]];
  return (
    <div data-testid="profile-check-card" className="rounded-2xl border p-5" style={{ borderColor: "#F2D98A", background: "#FFFBEB" }}>
      <div className="flex items-start gap-3">
        <ShieldCheck className="h-6 w-6 shrink-0" style={{ color: "var(--sj-primary)" }} />
        <div className="min-w-0 flex-1">
          <h3 className="font-head text-lg font-bold">Are your details still right?</h3>
          <p className="text-sm" style={{ color: "var(--sj-text-2)" }}>Once a year we ask you to check your contact details and emergency contact, so we can reach you and your family when it matters.</p>
          <dl className="mt-3 grid sm:grid-cols-2 gap-x-6 gap-y-1 text-sm">
            {rows.map(([k, v]) => (
              <div key={k} className="flex gap-2 min-w-0"><dt className="shrink-0" style={{ color: "var(--sj-text-3)" }}>{k}:</dt><dd className="truncate font-medium" style={{ color: v ? "var(--sj-text)" : "#B45309" }}>{v || "Not added"}</dd></div>
            ))}
          </dl>
          <div className="mt-4 flex flex-wrap gap-2">
            <button data-testid="profile-check-confirm" onClick={confirmOk} className="rounded-full px-5 py-2 text-sm font-semibold text-white" style={{ background: "var(--sj-primary)" }}>Yes, all correct</button>
            <button data-testid="profile-check-update" onClick={onEdit} className="rounded-full px-5 py-2 text-sm font-semibold border bg-white" style={{ borderColor: "var(--sj-border)", color: "var(--sj-primary)" }}>Update my details</button>
            <button data-testid="profile-check-later" onClick={later} className="rounded-full px-4 py-2 text-sm" style={{ color: "var(--sj-text-3)" }}>Remind me later</button>
          </div>
        </div>
      </div>
    </div>
  );
};
